module.exports = __webpack_public_path__ + "img/svg/edit.b9eecd55750bc35a86914f18c7f14251.svg";